<template>
  <v-card :loading="loading">
    <v-card-title class="font-weight-regular">
      {{ $t('EMPLOYEES.ACCESS_TO_THE_MYE_REPORTER') }}
      <v-icon
        v-if="!editMode"
        class="ml-2"
        color="indigo"
        @click="toggleEditMode"
      >
        mdi-square-edit-outline
      </v-icon>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <employee-access-mye-reporter-form
          v-model="form.user"
          :readonly="!editMode"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />

        <v-row dense>
          <v-col cols="12" class="pt-0">
            <div v-if="editMode">
              <v-btn
                outlined
                class="mr-5"
                depressed
                color="grey"
                large
                v-on="{
                  click: [reset, cancel]
                }"
              >
                {{ $t('BUTTON.CANCEL') }}
              </v-btn>
              <v-btn
                depressed
                type="submit"
                :disabled="!valid"
                large
                color="primary"
                class="mr-5"
                @click.prevent="update"
              >
                {{ $t('BUTTON.UPDATE') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import EmployeeAccessMyeReporterForm from '../components/forms/EmployeeAccessMyeReporterForm';
import editComponent from '@/modules/_global/mixins/edit-component';
import { EmployeesService } from '@/services/employees.service';

export default {
  name: 'EmployeeAccessMyeReporter',

  components: {
    EmployeeAccessMyeReporterForm
  },

  mixins: [errors, editComponent],

  methods: {
    update() {
      EmployeesService.updateUser(this.form.id, this.form.user)
        .then(() => {
          this.form.user.password = null;
          this.toggleEditMode();
          this.$emit('input', { ...this.form });
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
